module.exports = __webpack_public_path__ + "img/exit.818bda4e.svg";